import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, Tag } from 'lucide-react';
import { blogPosts } from '../data/siteData';
import { Badge } from '../components/ui/badge';

export default function BlogPage() {
  return (
    <div data-testid="blog-page" className="pt-20">
      {/* Header */}
      <section className="py-16 md:py-24 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#47ace2] font-manrope">
            Insights
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-slate-900 font-outfit mt-4">
            Blog & News
          </h1>
          <p className="text-lg text-slate-600 font-manrope mt-4 max-w-2xl">
            Stay updated with the latest trends in real estate, market insights, 
            and tips for homebuyers.
          </p>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <article
                key={post.id}
                data-testid={`blog-post-${post.id}`}
                className="bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all group"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-4 mb-4">
                    <Badge variant="secondary" className="bg-[#F0F8FF] text-[#47ace2]">
                      <Tag className="w-3 h-3 mr-1" />
                      {post.category}
                    </Badge>
                    <span className="text-slate-500 text-sm font-manrope flex items-center gap-1">
                      <Calendar className="w-3 h-3" />
                      {post.date}
                    </span>
                  </div>
                  <h2 className="text-xl font-semibold text-slate-900 font-outfit mb-3 group-hover:text-[#47ace2] transition-colors">
                    {post.title}
                  </h2>
                  <p className="text-slate-600 font-manrope text-sm line-clamp-2 mb-4">
                    {post.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1 text-[#47ace2] font-medium text-sm group-hover:gap-2 transition-all">
                    Read More
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </article>
            ))}
          </div>

          {/* Load More */}
          <div className="text-center mt-12">
            <p className="text-slate-500 font-manrope">
              More articles coming soon...
            </p>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="py-16 md:py-24 bg-slate-900 text-white">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
          <h2 className="text-3xl md:text-4xl font-light tracking-tight font-outfit mb-6">
            Subscribe to Our Newsletter
          </h2>
          <p className="text-slate-300 font-manrope mb-8">
            Get the latest real estate insights, market updates, and exclusive offers 
            delivered to your inbox.
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              data-testid="blog-newsletter-email"
              className="flex-1 px-4 py-3 rounded-full bg-slate-800 border border-slate-700 text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-[#47ace2] font-manrope"
            />
            <button
              type="submit"
              data-testid="blog-newsletter-submit"
              className="px-8 py-3 bg-[#47ace2] hover:bg-[#1f7db3] text-white rounded-full font-medium transition-colors"
            >
              Subscribe
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}
